<template>
	<div>
		<a-page-header style="background: #fff;" title="订单详情" />
		<div class="mainBox">
			<div class="searchBox" v-if="basicForm">
				<div style="font-size: 26px;font-weight: 700;padding: 20px;">
					订单状态：
					<!-- <span style="color: #ffc53d;" v-if="basicForm.orderStatus == 2">预约订单</span>
					<span style="color: #40a9ff;" v-if="basicForm.orderStatus == 3">待核销</span> -->
					<span style="color: #73d13d;" v-if="basicForm.orderStatus == 4">已付款</span>
				</div>
				<a-page-header :ghost="false">
					<a-descriptions :column="2">
						<a-descriptions-item label="订单号"><strong>{{basicForm.orderNum}}</strong></a-descriptions-item>
						<a-descriptions-item label="下单时间"><strong>{{basicForm.payTime}}</strong></a-descriptions-item>
						<a-descriptions-item label="支付方式">
							<a-tag color="green" v-if="basicForm.orderPayType == 1">
								<a-icon type="wechat" /> 微信支付</a-tag>
							<a-tag color="blue" v-if="basicForm.orderPayType == 2">
								<a-icon type="wallet" /> 钱包支付</a-tag>
						</a-descriptions-item>
						<a-descriptions-item label="支付单号"><strong>{{basicForm.orderPayType == 1 ? basicForm.orderWxpayNum : '无'}}</strong></a-descriptions-item>
						<a-descriptions-item label="会员信息">
							<strong>
								<a-icon type="user" /> {{basicForm.name}}
								<a-icon type="mobile" /> {{basicForm.phone}}
              </strong>
            </a-descriptions-item>
            <!-- <a-descriptions-item label="会员信息">
							<a-tag color="orange" v-if="basicForm.memberInfo.memberSfName">{{basicForm.memberInfo.memberSfName}}</a-tag>
							<strong>
								<a-icon type="user" /> {{basicForm.memberInfo.memberName}}
								<a-icon type="mobile" /> {{basicForm.memberInfo.memberPhone}}</strong></a-descriptions-item> -->
						<!-- <a-descriptions-item label="微信信息">
							<a-avatar :src="basicForm.wxInfo.headpic" size="small" /> {{basicForm.wxInfo.nickname}}
							<a-icon type="man" style="color:#597ef7 ;" v-if="basicForm.wxInfo.sex == 1" />
							<a-icon style="color:#f759ab ;" type="woman" v-if="basicForm.wxInfo.sex == 2" />
						</a-descriptions-item> -->
						<a-descriptions-item label="收货地址" :span="2">{{basicForm.address}}</a-descriptions-item>
						<a-descriptions-item label="备注" :span="2">{{basicForm.orderContent}}</a-descriptions-item>
            <a-descriptions-item label="评价星级" :span="2" v-if="basicForm.orderStatus == 4&&basicForm.evaInfo">
            	<a-rate :default-value="basicForm.evaInfo.appraiseRate" disabled />
            </a-descriptions-item>
            <a-descriptions-item label="评价内容" :span="2" v-if="basicForm.orderStatus == 4&&basicForm.evaInfo">
            	{{basicForm.evaInfo.appraiseContent}}
            </a-descriptions-item>
					</a-descriptions>
				</a-page-header>
			</div>
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="basicForm.goodsInfo" rowKey="id" :pagination="false" :loading="loading">
					<span slot="goodsThumb" slot-scope="goodsThumb">
						<a-avatar shape="square" :src="goodsThumb" :size="70" />
					</span>
					<span slot="goodsDelivery" slot-scope="goodsDelivery">
						<a-tag color="green" v-if="goodsDelivery == 1">现货</a-tag>
						<a-tag color="blue" v-if="goodsDelivery == 2">隔日到</a-tag>
					</span>
					<span slot="className" slot-scope="className">
						<a-tag color="blue" v-if="className">{{className}}</a-tag>
					</span>
					<span slot="goodsName" slot-scope="text,goodsName">
						{{goodsName.goodsName}}<a-tag color="orange" v-if="goodsName.isSaleGoods == 1">特价商品</a-tag>
					</span>
					<span slot="goodsPrice" slot-scope="text,goodsPrice">
							<span style="font-weight: 700;">{{goodsPrice.goodsPrice}} 元 × {{goodsPrice.orderPayNum}} = {{goodsPrice.goodsPrice * goodsPrice.orderPayNum}} 元</span>
							<!-- <div style="">送积分 {{goodsPrice.Integral}} 积分</div> -->
					</span>
				</a-table>
				<div style="text-align: right;padding: 10px 0;">
					 <!-- <div style="font-size: 22px;margin-right: ;">送积分：{{basicForm.orderAllIntegral}}积分 </div> -->
           <div style="font-size: 26px;font-weight: 700;">合计：{{basicForm.orderPayAll}}元</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '商品分类',
			dataIndex: 'className',
			scopedSlots: {
				customRender: 'className'
			},
		},
		{
			title: '商品名称',
			dataIndex: 'goodsName',
			scopedSlots: {
				customRender: 'goodsName'
			},
		},
		{
			title: '缩略图',
			dataIndex: 'goodsThumb',
			scopedSlots: {
				customRender: 'goodsThumb'
			},
		},
		{
			title: '售价',
			dataIndex: 'goodsPrice',
			scopedSlots: {
				customRender: 'goodsPrice'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				loading: false,
				basicForm: {}
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
		},
		methods: {
			getDetail() {
				this.loading = true
				this.$http.post('/admin/index.php/admin/Shop/ordersInfo', {
					id: this.id,
				}).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.basicForm = res.data.data


					}
				})
			},
		},
	}
</script>

<style scoped="">
</style>
